import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { SUPPORTED_LANG } from './Constants/constants';
import resources from './locales';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: SUPPORTED_LANG.EN, // default language
    fallbackLng: SUPPORTED_LANG.EN,
    interpolation: {
      escapeValue: false // react already escapes by default
    }
  });

export default i18n;
